var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eUT4k7PHSoh1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUT4k7PHSoh2-fill",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUT4k7PHSoh2-fill-0",
    offset: "0%",
    stopColor: "#9f73ab"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUT4k7PHSoh2-fill-1",
    offset: "23%",
    stopColor: "#9f73ab"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUT4k7PHSoh2-fill-2",
    offset: "52%",
    stopColor: "#9f73ab"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUT4k7PHSoh2-fill-3",
    offset: "86%",
    stopColor: "#1b2430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUT4k7PHSoh3-fill",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUT4k7PHSoh3-fill-0",
    offset: "0%",
    stopColor: "#9f73ab"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUT4k7PHSoh3-fill-1",
    offset: "23%",
    stopColor: "#9f73ab"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUT4k7PHSoh3-fill-2",
    offset: "52%",
    stopColor: "#9f73ab"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUT4k7PHSoh3-fill-3",
    offset: "86%",
    stopColor: "#1b2430"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.942962,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "matrix(0 15.935297-1 0 7.648577 2.648568)",
    fill: "url(#eUT4k7PHSoh2-fill)",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.942962,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "matrix(15.935294 0 0 1 5.148577 2.648568)",
    fill: "url(#eUT4k7PHSoh3-fill)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCorner);
export default __webpack_public_path__ + "static/media/LeftCorner.b0bfaa7c425aaadbae7aaca8f734b3d5.svg";
export { ForwardRef as ReactComponent };